import { Component, Input, OnInit } from '@angular/core';
import { BackendInfo } from '@colimo/colimo-ui-library';
import {TranslateModule} from "@ngx-translate/core";

/**
 * Component responsible for displaying important information about the backend.
 */
@Component({
  selector: 'colimo-backend-info',
  templateUrl: './backend-info.component.html',
  styleUrls: ['./backend-info.component.scss'],
  imports: [
    TranslateModule
  ]
})
export class BackendInfoComponent implements OnInit {
  @Input() public backendInfo: BackendInfo;

  constructor() {}

  public ngOnInit(): void {}
}
